import { Modal, Button as BootstrapButton } from 'react-bootstrap';
import { t } from 'i18next';

const TermsAndConditions = ({ showTerms, onClose }) => {

    return (
        <div className='terms-popup'>
            <div className='terms-content'>
                <Modal
                        show={showTerms}
                        onHide={onClose}
                        backdrop="static"
                        keyboard={false}
                    >
                        <Modal.Header closeButton>
                        <Modal.Title>{t("terms_and_conditions")}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body style={{ maxHeight: '45em', overflowY: 'auto' }}>
                            <h2>Privacy Policy</h2>
                            <p>XPay Egypt is committed to protecting your privacy and ensuring the security of your personal information. Our Privacy Policy outlines how we collect, use, disclose, and safeguard your data when you use our services.</p>
                            <h5><strong>Information We Collect</strong></h5>
                            <small>
                                We collect personal information necessary to provide and improve our services, including:
                                <ul>
                                    <li>Personal Identification Information: Name, address, phone number, email ID, and contacts.</li>
                                    <li>Financial Information: Bank account details, transaction history, and payment preferences.</li>
                                    <li>Device Information: Device identifiers, IP address, and location data.</li>
                                    <li></li>
                                </ul>
                            </small>
                            <h5><strong>How We Use Your Information</strong></h5>
                            <small>
                                <p>Your personal information is used to:</p>
                                <ul>
                                    <li>Provide and Maintain Services: Create your account, verify your identity, and manage your access privileges.</li>
                                    <li>Process Transactions: Facilitate payments on your behalf and on your instructions.</li>
                                    <li>Enhance User Experience: Analyze user behavior to improve our platform and customize services.</li>
                                    <li>Ensure Compliance: Conduct necessary compliance processes as required by regulatory bodies.</li>
                                    <li></li>
                                </ul>
                            </small>
                            <h5>Information Sharing</h5>
                            <small>
                                <p>We may share your personal information with:</p>
                                <ul>
                                    <li>Service Providers: Third-party companies that assist in providing our services. </li>
                                    <li>Financial Institutions: To process your financial transactions. </li>
                                    <li>Regulatory Authorities: To comply with legal obligations and regulatory requirements.</li>
                                    <li></li>
                                </ul>
                            </small>
                            <h5>Data Security</h5>
                            <small>
                                <p>We implement multiple levels of security to safeguard your personal information. However, it is your responsibility to protect your login credentials and notify us in case of any actual or suspected compromise.</p>
                            </small>
                            <h5>Your Consent</h5>
                            <small>
                                <p>By using the XPay platform or services and providing your personal information, you consent to the processing of your information in accordance with this Privacy Policy.</p>
                            </small>
                            <h2>Refund Policy</h2>
                            <small>
                                <p>XPay Egypt's refund policy allows refunds to be processed within 90 days of the original transaction, provided there are sufficient funds in your account.</p>
                            </small>
                            <h5>How to Process a Refund:</h5>
                            <ol>
                                <li>Identify the Transaction: Locate the specific transaction you wish to refund.</li>
                                <li>Initiate the Refund: Select the transaction, navigate to the 'Actions' menu, and choose 'Refund.'</li>
                                <li>Enter Refund Details: Specify the amount to be refunded.</li>
                                <li>Confirm the Refund: Submit the refund request to process the transaction.</li>
                                <li></li>
                            </ol>
                            <small>
                                <p>Please note that the refunded amount will be returned to the original payment method used. The time it takes for the refund to reflect in your account may vary depending on your bank or payment provider.</p>
                                <p>For more detailed information, please refer to XPay Egypt's User Manual. </p>
                                <p>If you have any questions or require assistance with processing a refund, please contact XPay Egypt's customer support team for further guidance.</p>
                            </small>
                        </Modal.Body>
                        <BootstrapButton onClick={onClose}>{t('close')}</BootstrapButton>
                    </Modal>
            </div>
        </div>
    );
};

export default TermsAndConditions;